import { combineReducers } from 'redux'

import warnings from './warnings'

export const supportReducer = combineReducers({
  warnings,
})
